import {ConfiguratorScreen, SummaryScreen} from "../screens";
import {useEffect, useState} from "react";
import type {IPlanItem} from "../components/PlanItem";
import {v4 as uuidv4} from "uuid";
import ReactTooltip from "react-tooltip";
import {toJpeg, toSvg} from 'html-to-image';
import {useActions} from "../hooks";


const STEPS_COUNT = 3;
const BORDER_TYPES = ['barierka', 'deska_okalajaca', 'listwa_odbojowa'];

export default function ConfiguratorContainer(props) {
  const actions = useActions();
  const [step, setStep] = useState(0);
  const [planImage, setPlanImage] = useState(null);
  const [elements: IPlanItem[], setElements] = useState([
    // {
    //   id: uuidv4(),
    //   x: 1500,
    //   y: 0,
    //   product: {
    //     id: 0,
    //     name: 'Słupek stabilizujący z mocowaniem i prowadnicą',
    //     width: 150,
    //     height: 100,
    //     depth: 10,
    //     price: 250,
    //   },
    //   elements: [],
    // }
  ]);
  const [cart, setCart] = useState([]);
  const [processing, setProcessing] = useState(false);
  const [error, setError] = useState(null)


  useEffect(() => {
    const anchorSystemID = uuidv4();

    const cart = elements.reduce((items, item) => {
      const arr = [...items];
      const idx = arr.findIndex(i => i.id === item.product.id);
      if (idx !== -1) {
        arr[idx].value += 1;
        arr[idx].price += item.product.price;
      } else {
        arr.push({
          id: item.product.id,
          value: 1,
          price: item.product.price,
          product: item.product,
        })
      }


      if (item.product.type === 'panel') {
        const anchorIdx = arr.findIndex(i => i.id === anchorSystemID);
        if (anchorIdx !== -1) {
          arr[anchorIdx].price += 55;
        } else {
          arr.push({id: anchorSystemID, value: 1, price: 110, product: {name: 'Ankerung', price: 110}})
        }
      }


      item.elements.map(el => {
        const idx = arr.findIndex(i => i.id === el.product.id);
        if (idx !== -1) {
          let value = Number(el.value);
          let price = value * el.product.price;

          if (BORDER_TYPES.includes(el.product.type)) {
            if (['left', 'right'].includes(el.place)) {
              value = (item.product.height / 100);
              price = Number(el.value) * el.product.price * value;
            } else {
              value = item.product.width / 100
              price = Number(el.value) * el.product.price * value;
            }
            el.elements.filter(i => i.type === 'gate').map(i => {
              if (i.width > 0) {
                const v = i.width / 100
                value -= v
                price = Number(el.value) * el.product.price * value;
              }
            })
          }

          arr[idx].value += value;
          arr[idx].price += price;
        } else {
          let value = Number(el.value);
          let price = value * el.product.price;

          if (BORDER_TYPES.includes(el.product.type)) {
            if (['left', 'right'].includes(el.place)) {
              value = (item.product.height / 100);
              price = Number(el.value) * el.product.price * value;
            } else {
              value = item.product.width / 100
              price = Number(el.value) * el.product.price * value;
            }
            el.elements.filter(i => i.type === 'gate').map(i => {
              if (i.width > 0) {
                const v = i.width / 100
                value -= v
                price = Number(el.value) * el.product.price * value;
              }
            })
          }

          arr.push({
            id: el.product.id,
            value,
            price,
            product: el.product,
          })
        }
      })
      return arr
    }, [])


    // cart.push({
    //   id: uuidv4(),
    //   value: 1,
    //   price: 1000,
    //   product: {id: -1, name: 'Montaż na terenie kraju', price: 1000},
    // })

    cart.push({
      id: uuidv4(),
      value: 1,
      price: 0,
      product: {id: -1, name: 'Transport', price: 0},
    })

    cart.sort((a, b) => a.product.type?.startsWith('panel_') ? -1 : 1)
      .sort((a, b) => a.product.type === 'panel' ? -1 : 1)
      .sort((a, b) => a.product.id === 0 ? -1 : 1)
      .sort((a, b) => a.product.id === -1 ? 1 : 0)

    setCart(cart);
  }, [elements])


  useEffect(() => {
    window.top.scrollTo({top: 0})
  }, [step])

  useEffect(() => {
    ReactTooltip.rebuild()
  }, [elements])


  const handleChangeElements = (elements) => {
    setElements(elements);
  }


  const handleNextStep = async () => {
    if (elements.length < 1)
      return;


    const minX = (() => {
      const item = elements.reduce((prev, next) => {
        const [prevEl, nextEl] = getPrevAndNextElement(prev, next)
        if (!prev)
          return next

        const [transformXPrev, transformXNext] = getPrevAndNextX(prevEl, nextEl)
        return transformXPrev < transformXNext ? prev : next
      })

      if (!item)
        return 0
      const el = document.getElementById(`planItem_${item.id}`)
      return Number(el.style.transform.match(/\(\d+px,/)[0]?.replace(/[(px,]/g, ''))
    })()
    const maxX = (() => {
      const item = elements.reduce((prev, next) => {
        const [prevEl, nextEl] = getPrevAndNextElement(prev, next)
        if (!prev)
          return next

        const [transformXPrev, transformXNext] = getPrevAndNextX(prevEl, nextEl)
        return transformXPrev > transformXNext ? prev : next
      })

      if (!item)
        return 0
      const el = document.getElementById(`planItem_${item.id}`)
      return Number(el.style.transform.match(/\(\d+px,/)[0]?.replace(/[(px,]/g, ''))
    })()
    const minY = (() => {
      const item = elements.reduce((prev, next) => {
        const [prevEl, nextEl] = getPrevAndNextElement(prev, next)
        if (!prev)
          return next

        const [transformXPrev, transformXNext] = getPrevAndNextY(prevEl, nextEl)
        return transformXPrev < transformXNext ? prev : next
      })

      if (!item)
        return 0
      const el = document.getElementById(`planItem_${item.id}`)
      return Number(el.style.transform.match(/\d+px\)/)[0]?.replace(/[px)]/g, ''))
    })()
    const maxY = (() => {
      const item = elements.reduce((prev, next) => {
        const [prevEl, nextEl] = getPrevAndNextElement(prev, next)
        if (!prev)
          return next

        const [transformXPrev, transformXNext] = getPrevAndNextY(prevEl, nextEl)
        return transformXPrev > transformXNext ? prev : next
      })

      if (!item)
        return 0
      const el = document.getElementById(`planItem_${item.id}`)
      return Number(el.style.transform.match(/\d+px\)/)[0]?.replace(/[px)]/g, ''))
    })()


    const plan = document.getElementById('draggablePlanWrapper');
    const oldTransform = plan.style.transform;
    plan.style.transform = `translate(0px, 0px)`
    const width = maxX - minX + 300
    plan.style.width = `${width < 700 ? 700 : width}px`
    plan.style.height = `${maxY - minY + 550}px`
    // const height = maxY - minY + 550
    // const size = width < 700 && height < 700 ? 700 : width < height ? height : width
    // plan.style.width = `${size}px`
    // plan.style.height = `${size}px`
    // console.log(minX, maxX, minY, maxY)

    const prevTransforms = []
    elements.map(item => {
      const el = document.getElementById(`planItem_${item.id}`)
      prevTransforms.push(el.style.transform)

      const x = Number(el.style.transform.match(/\(\d+px,/)[0]?.replace(/[(px,]/g, ''))
      const y = Number(el.style.transform.match(/\d+px\)/)[0]?.replace(/[px)]/g, ''))

      el.style.transform = `translate(${x - minX + 10}px, ${y - minY + 10}px)`
    })

    await toJpeg(plan)
      .then(base64 => {
        plan.style.transform = oldTransform;
        plan.style.width = '3000px';
        plan.style.height = '3000px';
        elements.map((item, idx) => {
          const el = document.getElementById(`planItem_${item.id}`)
          el.style.transform = prevTransforms[idx]
        })
        setPlanImage(base64)
        setStep(prev => {
          const newStep = prev + 1;
          return newStep < STEPS_COUNT ? newStep : prev;
        });
      })
      .catch(err => {
        console.error(err)
      })

    function getPrevAndNextElement(prev, next) {
      const prevEl = document.getElementById(`planItem_${prev?.id}`)
      const nextEl = document.getElementById(`planItem_${next?.id}`)
      return [prevEl, nextEl]
    }

    function getPrevAndNextX(prev, next) {
      const transformPrev = Number(prev.style.transform.match(/\(\d+px,/)[0]?.replace(/[(px,]/g, ''))
      const transformNext = Number(next.style.transform.match(/\(\d+px,/)[0]?.replace(/[(px,]/g, ''))
      return [transformPrev, transformNext]
    }

    function getPrevAndNextY(prev, next) {
      const transformPrev = Number(prev.style.transform.match(/\d+px\)/)[0]?.replace(/[px)]/g, ''))
      const transformNext = Number(next.style.transform.match(/\d+px\)/)[0]?.replace(/[px)]/g, ''))
      return [transformPrev, transformNext]
    }
  }

  const handlePrevStep = () => {
    setStep(prev => {
      const newStep = prev - 1;
      return newStep >= 0 ? newStep : prev;
    });
  }

  const handleSubmit = async (data) => {
    const formData = {
      firstname: data.firstname,
      lastname: data.lastname,
      postal: data.postal,
      city: data.city,
      phone: data.phone,
      email: data.email,
      address_line1: data.addressLine1,
      address_line2: data.addressLine2,
      custom_address: data.customAddress,
      color: data.color === 'custom' ? data.customColor : data.color,
      comments: data.comments,
      image: planImage,
      products: cart,
    };

    setProcessing(true)
    setError(null)
    await actions.addOrder(formData)
      .then(res => {
        if (res.status === 'success') {
          window.location.href = res.pdf
          // setStep(prev => {
          //   const newStep = prev + 1;
          //   return newStep < STEPS_COUNT ? newStep : prev;
          // })
        } else {
          alert('Coś poszło nie tak! Spróbuj ponownie.')
        }
      })
      .catch(err => {
        setError('Nie możemy w tej chwili przetworzyć Twojego zamówienia. Spróbuj ponownie.')
      })
    setProcessing(false)
  }

  const toggleMontaz = () => {
    const idx = cart.findIndex(i => i.product.type === 'montaz');
    const arr = [...cart]
    if (idx !== -1) {
      arr.splice(idx, 1)
    } else {
      arr.push({
        id: uuidv4(),
        value: 1,
        price: 500,
        product: {id: -1, name: 'Montage in Deutschland', price: 500, type: 'montaz'},
      })
    }
    setCart(arr)
  }

  const toggleRejestracjaJednostki = () => {
    const idx = cart.findIndex(i => i.product.type === 'rejestracja_jednostki');
    const arr = [...cart]
    if (idx !== -1) {
      arr.splice(idx, 1)
    } else {
      arr.push({
        id: uuidv4(),
        value: 1,
        price: 120,
        product: {
          id: -2,
          name: 'Anmeldung des Wasserfahrzeuges und Erledigung aller Formalitäten für den Auftraggeber ',
          price: 120,
          type: 'rejestracja_jednostki'
        },
      })
    }
    setCart(arr)
  }

  const cartSum = cart.reduce((value, item) => value + item.price, 0)
  const montazChecked = cart.find(i => i.product.type === 'montaz');
  const rejestracjaJednostkiChecked = cart.find(i => i.product.type === 'rejestracja_jednostki');

  return (
    <>
      <div hidden={step !== 0}>
        <ConfiguratorScreen
          elements={elements}
          cart={cart}
          montazChecked={montazChecked}
          rejestracjaJednostkiChecked={rejestracjaJednostkiChecked}
          toggleRejestracjaJednostki={toggleRejestracjaJednostki}
          toggleMontaz={toggleMontaz}
          onChangeElements={handleChangeElements}
          nextStep={handleNextStep}
        />
      </div>

      <div hidden={step !== 1}>
        <SummaryScreen
          planImage={planImage}
          elements={elements}
          processing={processing}
          error={error}
          cart={cart}
          updateCart={cart => setCart(cart)}
          montazChecked={montazChecked}
          rejestracjaJednostkiChecked={rejestracjaJednostkiChecked}
          toggleRejestracjaJednostki={toggleRejestracjaJednostki}
          toggleMontaz={toggleMontaz}
          prevStep={handlePrevStep}
          onSubmit={handleSubmit}
        />
      </div>

      <div hidden={step !== 2} className="summaryScreen">
        <div className="container-fluid">
          <h3>Wycena została wygenerowana!</h3>
          <p>
            Dziękujemy za złożenie zamówienia. Wycena została wygenerowana i przesłana na podany adres email oraz email
            producenta.
          </p>
          <p><b>Kwota zaliczki: {(cartSum * 0.1).toFixed(2)} €</b></p>
          <p>
            Potwierdzeniem złożenia zamówienia będzie wpłata zaliczki na konto:
            <br/> Adam Perliński
            <br/> Kołątajew 6D
            <br/> 63-410 Ostrów Wlkp.
            <br/> <b>66 1050 1201  1000 0090 7290 6366</b>
            <br/> ING Bank Śląski
          </p>
          <p>Dziękujemy!</p>
        </div>
      </div>
    </>
  )
}
